import { RouteSurvey } from '../domain/route/RouteSurvey';
import { RouteSurveyDTO } from '../domain/route/RouteSurveyDTO';
import { RouteSurveyRepositoryDTO } from '../domain/route/RouteSurveyRepositoryDTO';

export class RouteSurveyMapper {
  static toDomain(survey: RouteSurveyDTO): RouteSurvey {
    const { id, route_id, vehicle_id, rating, comments, deleted, created_at, updated_at, deleted_at } = survey;

    return RouteSurvey.create(
      {
        route_id,
        vehicle_id,
        rating,
        comments,
        deleted,
        created_at,
        updated_at,
        deleted_at,
      },
      id
    );
  }

  static toRepository({ rating, comments }: RouteSurvey): RouteSurveyRepositoryDTO {
    return {
      rating,
      comments,
    };
  }

  static toDTO(survey: RouteSurvey): RouteSurveyDTO {
    return {
      id: survey.id,
      route_id: survey.route_id,
      vehicle_id: survey.vehicle_id,
      rating: survey.rating,
      comments: survey.comments,
      deleted: survey.deleted,
      created_at: survey.created_at,
      updated_at: survey.updated_at,
      deleted_at: survey.deleted_at,
    };
  }
}
